import React, { useState, useEffect, useLayoutEffect } from "react";
import { Container } from "react-bootstrap";
import { getTextFromCMS } from "../../actions/get-calls";
import Breadcrumb from "../../component/breadcrumb";

const PrivacyPolicy = () => {
    const [content, setContent] = useState(null);

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    useEffect(async () => {
        // Content
        const _setContent = await getTextFromCMS(6, 1);
        if (_setContent) setContent(_setContent.data[0]);
    }, []);

    return (
        <React.Fragment>
            <Container >
                <Breadcrumb url="/" chlidrenUrl="" text="Privacy Policy" />
                <div className="mhc-text">
                    <h1 className="fs-3">{content ? content.heading : 'Privacy Policy'}</h1>
                    {content ? <div dangerouslySetInnerHTML={{ __html: content.text }}></div> : ''}
                </div>
            </Container>
        </React.Fragment>
    )
}

export default PrivacyPolicy;